module.exports = __webpack_public_path__ + "img/BISCAYNE_XL.ac818a6b.png";